import { MockAuthProvider, isMockAuthEnabled } from "./mock-auth-provider";
import { SessionAuthProvider } from "./session-auth-provider";
import { DESCOPE_PROJECT } from "@/lib/auth/descope-project";

interface AuthProviderProps {
  children: React.ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  // DEV-only mock auth - this entire block is stripped from production builds
  // by Vite's dead code elimination since import.meta.env.DEV is replaced with false
  if (isMockAuthEnabled()) {
    console.warn(
      "[Auth] Running with MOCK authentication. This should only be used for local development.",
    );
    return <MockAuthProvider>{children}</MockAuthProvider>;
  }

  if (!DESCOPE_PROJECT.projectId) {
    throw new Error("VITE_DESCOPE_PROJECT_ID is required");
  }
  if (!DESCOPE_PROJECT.baseUrl) {
    throw new Error("VITE_DESCOPE_BASE_URL is required");
  }

  return (
    <SessionAuthProvider project={DESCOPE_PROJECT}>
      {children}
    </SessionAuthProvider>
  );
}
